import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import roleAppsList from "../component/roleAppsList";
import appBaseConfig from '../appBaseConfig/appBaseConfig.vue';
import { mapGetters, mapMutations } from "vuex";
import gameCenterConfig from '@/view/app/gameCenterConfig/gameCenterConfig';
export default {
  name: "AppConfig",
  mixins: [],
  components: {
    roleAppsList: roleAppsList,
    appBaseConfig: appBaseConfig,
    gameCenterConfig: gameCenterConfig
  },
  data: function data() {
    return {
      isBaseConfig: true,
      isGameCenterConfig: false,
      showAdd: true
    };
  },
  computed: _objectSpread({}, mapGetters("app", ["selectAppId", "isAdd"])),
  methods: _objectSpread(_objectSpread({}, mapMutations("app", ["setSelectAppId", "setIsAdd"])), {}, {
    addApp: function addApp() {
      this.setSelectAppId("");
      this.setIsAdd(1);
    },
    handleClick: function handleClick(tab) {
      this.closeTags();
      switch (tab.name) {
        case "isBaseConfig":
          this.isBaseConfig = true;
          this.showAdd = true;
          break;
        case "isGameCenterConfig":
          this.isGameCenterConfig = true;
          this.showAdd = false;
          break;
      }
    },
    closeTags: function closeTags() {
      this.isBaseConfig = false;
      this.isGameCenterConfig = false;
    }
  }),
  created: function created() {}
};